import * as React from "react";
import { Route } from 'react-router-dom';
import { Help } from './components/help/help.component';

export const CustomRoutes = [
    <Route exact path="/help" component={Help} />,
];

export default CustomRoutes;